import React from "react";
import { cls } from "cls";
import { Modal } from "@clarkinc/zest-design-system";
import MediaReviewThumbnail from "./MediaReviewThumbnail";
import { MediaIdentifier, MediaReview } from "./reviewModels";

const mediaLimit = 16;
interface Props {
  mediaReviews: Array<MediaReview>;
  handleSelectMediaElement: (newMedia: MediaIdentifier | undefined) => void;
  isProductReviewPage?: boolean;
}

const UserPhotosAndVideos = ({
  mediaReviews,
  handleSelectMediaElement,
  isProductReviewPage = false,
}: Props) => {
  return (
    <div
      className={`${
        isProductReviewPage ? "lt:mt-16" : ""
      } box padded user-uploaded-photo-grid`}
    >
      <div className={cls("flex", "justify-between", "items-start")}>
        <h4
          className={`${
            isProductReviewPage ? "" : "lt:text-lg xl:text-xl"
          } text-xl text-semibold leading-6`}
        >
          Customer Photos &amp; Videos
        </h4>
        {mediaReviews.length > mediaLimit ? (
          <Modal.Trigger
            theme="headless"
            htmlFor="zest-modal-button"
            className="bg-transparent shadow-none whitespace-nowrap"
            data-testid="see-all-media-reviews"
            onClick={() => {
              handleSelectMediaElement({
                // non-null assertion is safe because we know there is at least one media review for this component to be rendered

                id: mediaReviews[0]!.id,

                type: mediaReviews[0]!.type,
              });
            }}
            type="button"
            aria-label="See all media reviews"
            CustomTrigger={
              <span
                className={cls(
                  "text-green-500",
                  "underline",
                  "font-semibold",
                  "text-sm",
                  "decoration-1",
                )}
              >
                See all
              </span>
            }
          />
        ) : null}
      </div>
      <div className="thumbs thumbs--bg-cover">
        {mediaReviews.slice(0, mediaLimit).map((mediaReview, index) => (
          <MediaReviewThumbnail
            key={index}
            isProductReviewPage={isProductReviewPage}
            truncate={mediaLimit === index + 1}
            totalRemainingMediaReviews={mediaReviews.length - mediaLimit}
            productReviewIndex={index}
            mediaReview={mediaReview}
            setSelectedModalMedia={() => {
              handleSelectMediaElement({
                id: mediaReview.id,
                type: mediaReview.type,
              });
            }}
            iconClassName={cls("absolute", "fill-current", "text-white")}
          />
        ))}
      </div>
    </div>
  );
};

export default UserPhotosAndVideos;
